import React from 'react';
import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux'
import { isChrome, isFirefox, isSafari, isOpera, isIE, isEdge } from 'react-device-detect';

import { Modal, Button } from 'components';
import InnovationAnimate from 'resources/innovation-animate.svg'
import * as actionCreators from 'store/actions';

const Container = styled.div`
    background-color: var(--secondary-color);
    padding: 2rem;
    box-shadow: var(--box-shadow);
    display: flex;
    flex-direction: column;
    border-radius: 5px;
    justify-content: center;
    align-items: stretch;
    max-width: 25rem;
    width: 80vw;
    color: #fff;
`

const Title = styled.div`
    font-weight: bold;
    text-align: center;
    font-size: 1.2rem;
`

const Text = styled.span`
    font-size: 0.9rem;
    /* text-align: justify; */
    margin-top: 0.5rem;
`

const ListItem = styled.li`
    font-size: 0.9rem;
    /* text-align: justify; */
    margin-top: 0.5rem;
`

const Image = styled.img`
    width: 100%;
    max-width: 25rem;
    object-fit: cover;
    display: block;
    margin-left: auto;
    margin-right: auto;
`

const buttonStyle = {
    backgroundColor: 'var(--primary-color)',
    text: 'white',
    margin: '1rem 0 0 0'
}

const instructions = {
    chrome: {
        check: isChrome,
        steps: [
            'To the left of the web address. select the padlock icon',
            'Click Site settings',
            'Change the Notifications permission to Allow'
        ]
    },
    firefox: {
        check: isFirefox,
        steps: [
            'Click the padlock Fx89 in the address bar.',
            'Click the arrow in the Site Information drop-down panel.',
            'Click More information in the next panel to bring up the Page Info window.',
            'Click the Permissions tab.',
            'Under Send Notifications, change the permission to Allow',
        ]
    },
    safari: {
        check: isSafari,
        steps: [
            'Select Safari in the toolbar',
            'Select System Preferences',
            'Select Websites',
            'Select Notifications',
            'Find app.atomicly.io and select Allow'
        ]
    },
    opera: {
        check: isOpera,
        steps: [
            'Go to Settings.',
            'Click Advanced in the left sidebar, and click Privacy & security.',
            'Under Privacy and security, click Site settings.',
            'Click Notifications.',
            'Select app.atomicly.io and select Allow'
        ]
    },
    edge: {
        check: isEdge,
        steps: [
            'Select the ellipsis button at the top-right corner of the browser window',,
            'Select the Settings option',
            'Select the Advanced Settings option',
            'Select Manage under the Website Permissions',
            'Find app.atomicly.io and change the permission to Allow'
        ]
    },
}

const NotiPermissionModal = props => {
    const {} = props;
    const dispatch = useDispatch();
    const user = useSelector(state => state.auth.user)

    const onClose = () =>  {
        dispatch(actionCreators.setModal(null,null))
    }
    let content = ['Go to browser settings', 'Select notifications', 'Find app.atomicly.io and change the permission to Allow']
    Object.values(instructions).map(instruction => {
        if(instruction['check']){
            content = instruction['steps']
        }
    })

    return (
        <Modal onClose={onClose}>
            <Container>
                <Title>{Notification ? 'Need permission' : 'Not supported'}</Title>
                <Image src={InnovationAnimate}/>
                <Text>{Notification ? "We'll need to get permission before we can send you desktop notifications, please follow these steps: " : 'Browser notifications are not supported for your browser, you may want to either update your browser version or use another browser such as Chrome or Firebox'}</Text>
                {Notification && <ol style={{paddingLeft: '1rem', marginBlockStart: '0.5rem', marginBlockEnd: '0.5rem'}}>{content.map(step => (<ListItem>{step}</ListItem>))}</ol>}
                {Notification && <Text>Close this section and enable the desktop notification again, you may need to refresh your browser for the settings to take effect</Text>}
                <Button text='Close' styles={buttonStyle} onSelect={onClose}/>
            </Container>
        </Modal>
    )
}

export default NotiPermissionModal